/** Typed `getElementById` that fails loudly instead of returning null. */
export function el<T extends HTMLElement>(id: string): T {
  const node = document.getElementById(id)
  if (!node) throw new Error(`missing element #${id}`)
  return node as T
}

export function node<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag)
  if (className) element.className = className
  if (text !== undefined) element.textContent = text
  return element
}

export function clear(target: HTMLElement): void {
  target.replaceChildren()
}

/** Definition pair for the `.stats` grid. */
export function stat(label: string, value: string, tone?: 'good' | 'warn'): HTMLDivElement {
  const wrap = node('div')
  wrap.append(node('dt', undefined, label))
  const dd = node('dd', tone, value)
  wrap.append(dd)
  return wrap
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`
  return `${(n / (1024 * 1024)).toFixed(2)} MB`
}

export function download(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.append(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
